import type { No } from '@mymaxx/flow-engine';
import { Botao } from '@mymaxx/ui';
import { ArrowRight, Trash2 } from 'lucide-react';
import { CATALOGO_NOS, saidasDoNo } from './catalogo-nos';

/** Painel da conexão selecionada: de onde sai, para onde vai e como apagar. */
export function PropriedadesAresta({
  de,
  para,
  rotulo,
  onExcluir,
}: {
  de: No | undefined;
  para: No | undefined;
  rotulo: string | undefined;
  onExcluir: () => void;
}) {
  const saida = de ? saidasDoNo(de).find((s) => s.id === rotulo) : undefined;

  return (
    <aside className="flex w-80 shrink-0 flex-col border-l border-neutral-200 dark:border-neutral-800">
      <header className="border-b border-neutral-200 px-4 py-3 dark:border-neutral-800">
        <p className="text-sm font-medium">Conexão</p>
        <p className="mt-0.5 text-xs text-neutral-500">
          O caminho que a conversa segue entre dois passos.
        </p>
      </header>

      <div className="flex-1 space-y-3 p-4 text-sm">
        <Ponta
          rotulo="De"
          no={de}
          complemento={saida ? `saída “${saida.nome || 'única'}”` : null}
        />
        <div className="flex justify-center text-neutral-400">
          <ArrowRight size={16} />
        </div>
        <Ponta rotulo="Para" no={para} complemento={null} />

        <p className="rounded-lg bg-neutral-50 p-2 text-xs text-neutral-500 dark:bg-neutral-900">
          Para mudar o destino, arraste a ponta da conexão até outro nó. Para trocar a origem,
          arraste a partir do ponto de saída desejado.
        </p>
      </div>

      <footer className="border-t border-neutral-200 p-4 dark:border-neutral-800">
        <Botao variante="perigo" className="w-full" onClick={onExcluir}>
          <Trash2 size={14} /> Excluir conexão
        </Botao>
      </footer>
    </aside>
  );
}

function Ponta({
  rotulo,
  no,
  complemento,
}: {
  rotulo: string;
  no: No | undefined;
  complemento: string | null;
}) {
  if (!no) {
    return (
      <div className="rounded-lg border border-dashed border-neutral-300 p-2 text-xs text-neutral-500 dark:border-neutral-700">
        {rotulo}: nó não encontrado
      </div>
    );
  }
  const descricao = CATALOGO_NOS[no.tipo];

  return (
    <div className="rounded-lg border border-neutral-200 p-2 dark:border-neutral-700">
      <p className="text-[11px] text-neutral-500">{rotulo}</p>
      <p className="flex items-center gap-1.5 text-sm font-medium">
        <descricao.Icone size={14} style={{ color: descricao.cor }} />
        {descricao.nome}
      </p>
      {complemento && <p className="text-[11px] text-neutral-500">{complemento}</p>}
    </div>
  );
}
